export enum HtmlId {
    APP = 'fixnet-gigatv-mobile-app',
    LOADING = 'fixnet-loading-spinner',
    OFFER_SUMMARY_CARD = 'gigatv-app-offer-summary-card',
    RELATED_OFFER_LINKS = 'fixnet-related-links-offers',
    RELATED_OTHER_LINKS = 'fixnet-related-links',
    FAQ_ACCORDION = 'faq-accordion',
    FOOTNOTE_ACCORDION = 'fixnet-footnote-accordion',
    ICON_TEXT_BANNER = 'fixnet-icon-text-banner',
    BUTTON_LINK = 'fixnet-button-link',
}

export enum NameSpace {
    APP = 'GTVM/APP',
}

export enum HttpStatus {
    BAD_REQUEST = 400,
}

export enum Endpoints {
    JARVIS = '/api/jarvis/zuhauseplus/v1/getProductDetails',
    OPTION_PAGE = '/optionen/',
}

export enum Domains {
    ZH = 'https://zuhauseplus.vodafone.de',
    VF = 'https://eweb8.vfd2-testnet.de',
}

export enum Queries {
    BASKET = 'vfBasket'
}
